import { useLocalStorageSync } from "@spiriidk/utils";

/**
 * Hook for consuming and controlling sidebar state from anywhere in the app.
 * Synchronizes with the SidebarProvider's state via localStorage.
 *
 * @param storageKey - The localStorage key used by SidebarProvider
 * @param defaultValue - Default open state if no value is stored (defaults to true)
 * @returns Tuple of [isOpen, setIsOpen] for controlling sidebar state
 */
function useSidebarState(storageKey: string, defaultValue: boolean = true) {
  return useLocalStorageSync<boolean>({
    key: storageKey,
    defaultValue,
    serialize: (value) => String(value),
    deserialize: (value) => value === "true",
  });
}

export { useSidebarState };
